import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LoginPage.css';
import { API } from '../config';

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMsg('All fields are required');
      return;
    }

    setLoading(true);

    try {
      // Call Python API instead of static admin check
      const response = await fetch(API.LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: username, password }),
      });

      const 
      result = await response.json();

      if (result.success) {
        navigate('/product-dashboard');   // SUCCESS → Redirect
      } else {
        setErrorMsg(result.message);       // FAIL → Show error
        setLoading(false);
      }

    } catch (error) {
      setErrorMsg("Server error. Try again!");
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form onSubmit={handleLogin} className="login-form">
        <h2>Admin Login</h2>

        {errorMsg && <p className="error">{errorMsg}</p>}

        <input
          id="username"
          name="username"
          className='login'
          type="text"
          placeholder="Email"
          value={username}
          onChange={e => setUsername(e.target.value)}
          disabled={loading}
        />

        <input
          id="pwd"
          name="password"
          className='login'
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
        />

        <button type="submit" disabled={loading}>
          {loading ? <div className="spinner"></div> : 'Login'}
        </button>

      </form>
    </div>
  );
};

export default LoginPage;
